<template>
  <a-modal
      title="发票列表,请点击链接进行下载"
      :width="800"
      :visible="visible"
      :confirmLoading="loading"
      :maskClosable="false"
      :footer="null"
      @ok="() => { $emit('ok') }"
      @cancel="() => { $emit('onClose') }"
  >
    <a-spin :spinning="false">
      <a-list item-layout="horizontal"  :dataSource="sourceData">
        <template slot="renderItem" slot-scope="item,index" >
          <a-list-item>
            <a-list-item-meta>
              <template #title>
                <a>{{ tabTitle[index] }}</a>
              </template>
              <template #description>
                <a :href="item" target="_blank">{{ item }}</a>
              </template>
            </a-list-item-meta>
          </a-list-item>
        </template>
      </a-list>
    </a-spin>
  </a-modal>
</template>

<script>
const titles = ["发票一", "发票二", "发票三", "发票四", "发票五", "发票六", "发票七", "发票八", "发票九"]
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    urls: {
      type: Array,
      default: () => []
    },
  },
  data() {

    return {
      tabTitle: titles,
      activeKey: 1,
      sourceData: []
    }
  },
  created() {

  },
  methods: {},
  watch: {
    urls(newVal) {
      this.sourceData = newVal
    },
    visible(show) {//普通的watch监听
      if (!show) {
        this.sourceData = []
      }
    },
  }
}
</script>
